<template>
    <div>
        <div class="instanceList-title">
            <div>{{ $t('instance_list.swireInstanceList') }}</div>
            <div>
                <Button type="warning" :loading="modal_loading" @click="exportList" v-hasPermission="['instanceLists:instanceList:export']">{{ $t('common.export') }}</Button>
            </div>
        </div>
        <div class="instanceList-top">
            <instance-list-search ref="instanceSearchChild"></instance-list-search>
        </div>
        <table-instance-list></table-instance-list>
    </div>
</template>

<script>
    import InstanceListSearch from '../instance_list/InstanceListSearch'
    import TableInstanceList from '../instance_list/TableInstanceList'

    export default {
        name: 'InstanceList',
        components: {
            InstanceListSearch,
            TableInstanceList
        },
        data () {
            return {
                modal_loading:false,
                environmentKey:'',
                startDate:''
            }
        },
        methods: {
            //导出
            exportList: function () {
                // 获取子组件数据
                this.environmentKey=this.$refs.instanceSearchChild.environmentKey;
                this.startDate=this.$refs.instanceSearchChild.startDate;
                this.modal_loading = true
                this.$Message.loading({
                    duration: 0,
                    content: this.$t('common.exporting')
                })
                // 下载Excel 文件
                this.$api.swireOpsInstance.exportInstanceTask({
                    "environment": this.environmentKey,
                    "startDate": this.startDate
                })
                .then(res => {
                    let fileName = 'InstanceList.xls'
                    let blob = new Blob([res.data], {type: 'application/x-xls'})
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName);
                    } else {
                        var link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        link.click();
                        window.URL.revokeObjectURL(link.href);
                    }
                    this.modal_loading = false;
                    this.$Message.destroy();
                    this.$Message.success(this.$t('common.exportSuccess'));
                })
            }
        }
    }
</script>

<style scoped>
    .instanceList-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 0px 4px;
        font-weight: 600;
        overflow: hidden;
    }
    .instanceList-title>div:nth-child(1)
    {
        float:left;
    }
    .instanceList-title>div:nth-child(2)
    {
        float:right;
        margin-top: -6px;
    }
    .instanceList-top
    {
        width: 100%;
        height: 53px;
    }
</style>



// WEBPACK FOOTER //
// src/components/instance_lists/instance_list/InstanceList.vue